// Palette
import palette from '../palette';

export default {
  root: {
    backgroundColor: palette.primary.light,
    color: palette.background.dark,
  },
  clickable: {
    '&:hover, &:focus, &:active': {
      backgroundColor: palette.background.default,
    },
  },
  deletable: {
    '&:focus': {
      backgroundColor: palette.primary.light,
    },
  },
  outlined: {
    '&:hover': {
      backgroundColor: palette.primary.light,
    },
  },
};
